import {CLEAR_NOTIFICATION} from '../constants/Constants.js';

export function dismissNotification(key, timeout){
  return dispatch => {
    if(timeout){
      setTimeout(() => {
        dispatch({
          type: CLEAR_NOTIFICATION,
          notificationId: key
        });
      }, timeout);
    }else{
      dispatch({
        type: CLEAR_NOTIFICATION,
        notificationId: key
      });
    }
  };
}



// WEBPACK FOOTER //
// /src/actioncreators/AppActions.js